import { render, staticRenderFns } from "./changePwd.vue?vue&type=template&id=470327e9&scoped=true&lang=pug"
import script from "./changePwd.vue?vue&type=script&lang=js"
export * from "./changePwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470327e9",
  null
  
)

export default component.exports